import { ReactElement } from 'react';

import { Modal, ModalCancelButton, ModalCloseButton, ModalWidth } from '@dreryk/react-components';

import { calendarTranslationKeys } from '../../../../../translations';

type TimetablePreferencesModalProps = {
   onClose: VoidFunction;
   children: ReactElement;
};

export const TimetablePreferencesModal = (props: TimetablePreferencesModalProps): ReactElement => {
   return (
      <Modal
         testId={'calendarPreferences'}
         title={calendarTranslationKeys.calendarPreferences}
         width={ModalWidth.NORMAL}
      >
         <ModalCancelButton onClick={props.onClose} />
         <ModalCloseButton onClick={props.onClose} />
         {props.children}
      </Modal>
   );
};
